import { BUApplication } from "./BUApplication";

interface Blazor {
   addEventListener(
      eventName: 'enhancednavigationstart' | 'enhancednavigationend' | 'enhancedload',
      callback: () => void
   ): void;
   removeEventListener(
      eventName: 'enhancednavigationstart' | 'enhancednavigationend' | 'enhancedload',
      callback: () => void
   ): void;
}

declare const Blazor: Blazor | undefined;

export let gBuApp: BUApplication | undefined = undefined;

function spinner(show: boolean): void {
   const overlay = document.getElementById('buApp-busy-spinner-overlay');
   if (overlay) {
      overlay.style.display = show ? 'block' : 'none';
   }   
}

function scroller() {
   const url = new URL(window.location.href);
   if (url.searchParams.get('scr') === '1') {
      setTimeout(() => {
         window.scrollTo(0, 0);
      }, 100);
      url.searchParams.delete('scr');
      window.history.replaceState({}, '', url.toString());
   }
}

window.onload = function () {
   console.log("bu-app-start");
   gBuApp = new BUApplication();
   //@ts-ignore
   window.buApp = gBuApp;

   if (typeof Blazor !== 'undefined' && Blazor) {
      Blazor.addEventListener('enhancednavigationstart', () => {
         document.querySelectorAll('button[type="submit"]').forEach(btn => {
            //@ts-ignore
            btn.disabled = true;
         });
         spinner(true);
      });

      Blazor.addEventListener('enhancednavigationend', () => {
         spinner(false);         
      });
      Blazor.addEventListener('enhancedload', () => {
         spinner(false);
         scroller();        
         gBuApp?.onPageLoad();
      });
   }
   gBuApp?.onPageLoad();
}